<template>
  <el-dialog v-model="show.searchParam" :title="util.language('筛选条件', 'Search condition')" width="500" :close-on-click-modal="false">
    <el-form label-width="auto">
      <el-form-item :label="util.language('下单时间', 'Create time')">
        <el-date-picker style="width: 100%;" v-model="searchParam.createDatetimes" type="datetimerange" range-separator="~" />
      </el-form-item>
      <el-form-item :label="util.language('订单编号', 'Order code')">
        <el-input style="width: 100%;" :placeholder="util.language('精准匹配', 'Exact match')" v-model="searchParam.code" clearable />
      </el-form-item>
      <el-form-item :label="util.language('客户编号', 'Customer code')">
        <el-input style="width: 100%;" :placeholder="util.language('精准匹配', 'Exact match')" v-model="searchParam.customerCode" clearable />
      </el-form-item>
      <el-form-item :label="util.language('创建人编号', 'Creator code')">
        <el-input style="width: 100%;" :placeholder="util.language('精准匹配', 'Exact match')" v-model="searchParam.createUserCode" clearable />
      </el-form-item>
      <el-form-item :label="util.language('状态', 'State')">
        <el-select clearable multiple v-model="searchParam.stateList" style="width: 100%;">
          <el-option key="NEW" :label="util.language('新订单', 'New')" value="NEW" />
          <el-option key="SENT" :label="util.language('已发出', 'Sent')" value="SENT" />
          <el-option key="FINISH" :label="util.language('完成', 'Finish')" value="FINISH" />
          <el-option key="CANCEL" :label="util.language('取消', 'Cancel')" value="CANCEL" />
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="show.searchParam = false">{{ util.language('关闭', 'Cancel') }}</el-button>
        <el-button @click="resetSearchParam()">{{ util.language('重置', 'Reset') }}</el-button>
        <el-button type="primary" @click="show.searchParam = false; commitFindList()">{{ util.language('搜索', 'Search') }}</el-button>
      </div>
    </template>
  </el-dialog>
  <div class="orders">
    <div style="margin-bottom: 10px;">
      <el-button-group size="small">
        <el-button type="primary" @click="commitFindList()" :loading="loading.find">{{ util.language('刷新', 'Refresh') }}</el-button>
        <el-tooltip :content="util.language('按当前筛选条件导出', 'Export by current search condition')" placement="top">
          <el-button type="warning" @click="exportExcel()" :loading="loading.exportExcel">{{ util.language('导出Excel', 'Export excel') }}</el-button>
        </el-tooltip>
        <el-button type="" @click="show.searchParam = true">{{ util.language('编辑筛选', 'Edit search') }}</el-button>
        <el-button @click="resetSearchParam()">{{ util.language('重置', 'Reset') }}</el-button>
        <el-tooltip :content="util.language('将逐个下载本页中已完成订单的发票', 'Export invoices for finished orders on this page')" placement="top">
          <el-button type="" @click="allInvoice()" :loading="loading.exportExcel">{{ util.language('批量下载发票', 'Export invoices') }}</el-button>
        </el-tooltip>
      </el-button-group>
      <el-text style="margin-left: 10px;" v-if="searchParam.createDatetimes.length == 2">
        {{ util.language('下单时间：', 'Create time: ') }}
        {{ util.parseTime(searchParam.createDatetimes[0]) }} ~ {{ util.parseTime(searchParam.createDatetimes[1]) }}
      </el-text>
      <el-text style="margin-left: 10px;" v-if="searchParam.code">
        {{ util.language('订单编号：', 'Order code: ') }}
        {{ searchParam.code }}
      </el-text>
      <el-text style="margin-left: 10px;" v-if="searchParam.customerCode">
        {{ util.language('客户编号：', 'Customer code: ') }}
        {{ searchParam.customerCode }}
      </el-text>
      <el-text style="margin-left: 10px;" v-if="searchParam.createUserCode">
        {{ util.language('创建人编号：', 'Creator code: ') }}
        {{ searchParam.createUserCode }}
      </el-text>
      <template v-if="searchParam.stateList && searchParam.stateList.length > 0">
        <el-text style="margin-left: 10px;">
          {{ util.language('状态：', 'State: ') }}
        </el-text>
        <el-text v-for="(state, stateIndex) in searchParam.stateList" :key="stateIndex">
          {{ state == 'NEW' ? util.language('新订单', 'New') : '' }}
          {{ state == 'SENT' ? util.language('已发出', 'Sent') : '' }}
          {{ state == 'FINISH' ? util.language('完成', 'Finish') : '' }}
          {{ state == 'CANCEL' ? util.language('取消', 'Cancel') : '' }}
        </el-text>
      </template>
    </div>
    <div style="height: calc(100vh - 170px); overflow-y: auto;" v-loading.body="loading.find">
      <el-empty v-if="!data.orderList || data.orderList.length == 0" :description="util.language('暂无数据', 'No data')" />
      <el-card shadow="hover" v-for="(order, orderIndex) in data.orderList" :id="order.orderMaster.code" :key="order.orderMaster.id" style="margin: 0 10px 20px 0;">
        <el-row :gutter="20">
          <el-col :span="24" style="background-color: rgb(243.9, 244.2, 244.8); padding: 10px;">
            <el-text style="margin-right: 10px;">#{{ orderIndex + 1 }}</el-text>
            <el-tag type="primary" v-if="order.orderMaster.state == 'NEW'">{{ util.language('新订单', 'New') }}</el-tag>
            <el-tag type="primary" v-if="order.orderMaster.state == 'SENT'">{{ util.language('已发出', 'Sent') }}</el-tag>
            <el-tag type="success" v-if="order.orderMaster.state == 'FINISH'">{{ util.language('完成', 'Finish') }}</el-tag>
            <el-tag type="info" v-if="order.orderMaster.state == 'CANCEL'">{{ util.language('取消', 'Cancel') }}</el-tag>
            <el-text style="margin-left: 10px;">
              {{ util.language('订单编号：', 'Order code: ') }}
              {{ order.orderMaster.code }}
            </el-text>
            <el-text style="margin-left: 10px;">
              {{ util.language('下单时间：', 'Create: ') }}
              {{ util.parseTime(order.orderMaster.createDatetime) }}
            </el-text>
            <el-text style="margin-left: 10px;" v-if="order.orderMaster.updateDatetime">
              {{ util.language('最近修改：', 'Update: ') }}
              {{ util.parseTime(order.orderMaster.updateDatetime) }}
            </el-text>
            <el-text style="margin-left: 10px;" v-if="order.orderMaster.finishDatetime">
              {{ util.language('完成时间：', 'Finish: ') }}
              {{ util.parseTime(order.orderMaster.finishDatetime) }}
            </el-text>
            <el-button-group style="float: right;">
              <el-button size="small" type="primary" @click="invoice(order)" :loading="loading.invoice">
                {{ util.language('发票', 'Invoice') }}
              </el-button>
              <el-button v-if="order.orderMaster.state == 'NEW'" size="small" type="success" @click="sendOrder(order)">
                {{ util.language('发运', 'Send') }}
              </el-button>
              <el-button v-if="order.orderMaster.state == 'SENT'" size="small" type="success" @click="finishOrder(order)">
                {{ util.language('完成', 'Finish') }}
              </el-button>
              <el-button v-if="order.orderMaster.state == 'NEW' || order.orderMaster.state == 'SENT'" size="small" type="info" @click="cancelOrder(order)">
                {{ util.language('取消', 'Cancel') }}
              </el-button>
              <el-button size="small" type="" @click="getHistory(order)">
                {{ util.language('历史', 'History') }}
              </el-button>
            </el-button-group>
          </el-col>
          <el-col :span="10">
            <div style="padding: 10px;">
              <template v-if="order.createUser && order.createUser.id">
                <el-text>{{ util.language('创建人：', 'Create by: ') }}</el-text>
                <el-text style="color: rgb(51.2, 126.4, 204);">{{ order.createUser.code }}</el-text>
                <el-text>{{ order.createUser.nick }}</el-text>
                <br />
              </template>
              <el-text>{{ util.language('店铺：', 'Shop: ') }}</el-text>
              <el-text style="color: rgb(51.2, 126.4, 204);">{{ order.shop.code }}</el-text>
              <el-text>{{ util.language(order.shop.cnName, order.shop.enName) }}</el-text>
              <br />
              <el-text>
                {{ util.language('电话：', 'Phone: ') }}
                {{ order.shop.phone }}
              </el-text>
              <br />
              <el-text>
                {{ util.language('地址：', 'Address: ') }}
                {{ order.shop.addressDetail }}
              </el-text>
            </div>
            <div style="padding: 10px;">
              <el-text>{{ util.language('客户：', 'Customer: ') }}</el-text>
              <el-text style="color: rgb(51.2, 126.4, 204);">{{ order.customer.code }}</el-text>
              <el-text>{{ order.customer.name }}</el-text>
              <br />
              <el-text>
                {{ util.language('客户电话：', 'Phone: ') }}
                {{ order.customer.phone }}
              </el-text>
              <br />
              <el-text>
                {{ util.language('客户已完成订单总计：', 'Total finished: ') }}
                {{ order.customer.finishOrderCount }}
              </el-text>
              <br />
            </div>
            <div style="padding: 10px;">
              <el-text>
                {{ util.language('收货联系人：', 'Contact: ') }}
                {{ order.orderMaster.addressContact }}
              </el-text>
              <el-button size="small" style="margin-left: 20px;" v-if="order.orderMaster.state == 'NEW' || show.admin" @click="editDeliveryInfo(order)">
                {{ util.language('编辑收货信息', 'Edit Delivery Info') }}
              </el-button>
              <br />
              <el-text>
                {{ util.language('收货联系电话：', 'Phone: ') }}
                {{ order.orderMaster.addressPhone }}
              </el-text>
              <br />
              <el-text>
                {{ util.language('收货地址：', 'Address: ') }}
                {{ order.orderMaster.addressDetail }}
              </el-text>
              <br />
              <el-text>
                {{ util.language('预约配送时间：', 'Schedule Delivery: ') }}
                {{ order.orderMaster.scheduleDeliveryDate }}
              </el-text>
              <template v-if="order.orderMaster.state == 'SENT' || order.orderMaster.state == 'FINISH'">
                <br />
                <el-text style="font-weight: 900;">
                  {{ util.language('实际配送时间：', 'Delivery: ') }}
                  {{ order.orderMaster.deliveryDate }}
                </el-text>
              </template>
            </div>
          </el-col>
          <el-col :span="14">
            <div style="padding: 10px;">
              <el-row :gutter="5" class="r-table-row">
                <el-col :span="14">
                  <el-text>{{ util.language('商品', 'Product') }}</el-text>
                </el-col>
                <el-col :span="4" style="text-align: right;">
                  <el-text>{{ util.language('数量', 'Quantity') }}</el-text>
                </el-col>
                <el-col :span="6" style="text-align: right;">
                  <el-text>{{ util.language('金额', 'Amount') }}</el-text>
                </el-col>
              </el-row>
              <el-row :gutter="5" class="r-table-row" v-for="orderDetail in order.orderDetailList" :key="orderDetail.id">
                <el-col :span="14">
                  <el-text>{{ util.language(orderDetail.productCnName, orderDetail.productEnName) }}</el-text>
                </el-col>
                <el-col :span="4" style="text-align: right;">
                  <el-text>{{ orderDetail.pieceQuantity }}</el-text>
                </el-col>
                <el-col :span="6" style="text-align: right;">
                  <el-text>{{ orderDetail.finalAmount }}</el-text>
                </el-col>
              </el-row>
              <el-row :gutter="5" style="height: 5px; border-bottom: rgb(177.3, 179.4, 183.6) 1px solid;">
              </el-row>
              <el-row :gutter="5" class="r-table-row">
                <el-col :span="14">
                  <el-text>{{ util.language('费用小计', 'Subtotal') }}</el-text>
                </el-col>
                <el-col :span="10" style="text-align: right;">
                  <el-text>{{ 'C$' + order.orderMaster.totalAmount }}</el-text>
                </el-col>
              </el-row>
              <el-row :gutter="5" class="r-table-row">
                <el-col :span="14">
                  <el-text>{{ util.language('总成本', 'Total cost') }}</el-text>
                </el-col>
                <el-col :span="10" style="text-align: right;">
                  <el-text>{{ 'C$' + order.orderMaster.totalCost }}</el-text>
                </el-col>
              </el-row>
              <el-row :gutter="5" class="r-table-row" v-if="order.orderMaster.hstRate">
                <el-col :span="14">
                  <el-text>{{ util.language('HST税率、税额', 'HST Rate & Amount') }}</el-text>
                </el-col>
                <el-col :span="10" style="text-align: right;">
                  <el-text>{{ math.multiply(order.orderMaster.hstRate, 100) + '%' }}</el-text>
                  <el-text> \ </el-text>
                  <el-text>{{ 'C$' + order.orderMaster.hstAmount }}</el-text>
                </el-col>
              </el-row>
              <el-row :gutter="5" class="r-table-row" v-if="order.orderMaster.gstRate">
                <el-col :span="14">
                  <el-text>{{ util.language('GST税率、税额', 'GST Rate & Amount') }}</el-text>
                </el-col>
                <el-col :span="10" style="text-align: right;">
                  <el-text>{{ math.multiply(order.orderMaster.gstRate, 100) + '%' }}</el-text>
                  <el-text> \ </el-text>
                  <el-text>{{ 'C$' + order.orderMaster.gstAmount }}</el-text>
                </el-col>
              </el-row>
              <el-row :gutter="5" class="r-table-row" v-if="order.orderMaster.pstRate">
                <el-col :span="14">
                  <el-text>{{ util.language('PST税率、税额', 'PST Rate & Amount') }}</el-text>
                </el-col>
                <el-col :span="10" style="text-align: right;">
                  <el-text>{{ math.multiply(order.orderMaster.pstRate, 100) + '%' }}</el-text>
                  <el-text> \ </el-text>
                  <el-text>{{ 'C$' + order.orderMaster.pstAmount }}</el-text>
                </el-col>
              </el-row>
              <el-row :gutter="5" class="r-table-row" v-if="order.orderMaster.qstRate">
                <el-col :span="14">
                  <el-text>{{ util.language('QST税率、税额', 'QST Rate & Amount') }}</el-text>
                </el-col>
                <el-col :span="10" style="text-align: right;">
                  <el-text>{{ math.multiply(order.orderMaster.qstRate, 100) + '%' }}</el-text>
                  <el-text> \ </el-text>
                  <el-text>{{ 'C$' + order.orderMaster.qstAmount }}</el-text>
                </el-col>
              </el-row>
              <el-row :gutter="5" class="r-table-row">
                <el-col :span="14">
                  <el-text>{{ util.language('费税合计', 'Final Amount') }}</el-text>
                </el-col>
                <el-col :span="10" style="text-align: right;">
                  <el-text>
                    {{ 'C$' + math.plus(order.orderMaster.totalAmount, order.orderMaster.hstAmount, order.orderMaster.gstAmount, order.orderMaster.pstAmount, order.orderMaster.qstAmount) }}
                  </el-text>
                </el-col>
              </el-row>
              <el-row :gutter="5" class="r-table-row" style="font-weight: bolder;">
                <el-col :span="14">
                  <el-text type="danger">{{ util.language('折扣', 'Discount') }}</el-text>
                </el-col>
                <el-col :span="10" style="text-align: right;">
                  <el-text type="danger">
                    {{ 'C$' + order.orderMaster.discountAmount }}
                  </el-text>
                </el-col>
              </el-row>
              <el-row :gutter="5" class="r-table-row" style="font-weight: bolder;">
                <el-col :span="14">
                  <el-text type="success">{{ util.language('总利润', 'Total profit') }}</el-text>
                </el-col>
                <el-col :span="10" style="text-align: right;">
                  <el-text type="success">{{ 'C$' + order.orderMaster.totalProfit }}</el-text>
                </el-col>
              </el-row>
              <el-row :gutter="5" class="r-table-row" style="font-weight: bolder;">
                <el-col :span="14">
                  <el-text type="success">{{ util.language('利润率', 'Profit rate') }}</el-text>
                </el-col>
                <el-col :span="10" style="text-align: right;">
                  <el-text type="success">{{ math.multiply(order.orderMaster.profitRate, 100) + '%' }}</el-text>
                </el-col>
              </el-row>
              <el-row :gutter="5" class="r-table-row" style="font-weight: bolder;">
                <el-col :span="14">
                  <el-text type="primary">{{ util.language('合计', 'Total') }}</el-text>
                </el-col>
                <el-col :span="4" style="text-align: right;">
                  <el-text type="primary">
                    {{order.orderDetailList.map(detail => detail.pieceQuantity).reduce((a, b) => a + b, 0)}}
                  </el-text>
                </el-col>
                <el-col :span="6" style="text-align: right;">
                  <el-text type="primary">
                    {{ 'C$' + order.orderMaster.finalAmount }}
                  </el-text>
                </el-col>
              </el-row>
              <el-row :gutter="5">
                <el-col :span="24">
                  <el-button size="small" style="float: right;" v-if="order.orderMaster.state == 'NEW' || show.admin" @click="editOrderDetail(order)">
                    {{ util.language('编辑商品详情', 'Edit Product Details') }}
                  </el-button>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top: 10px;">
          <el-col :span="8">
            <el-text>
              {{ util.language('客户备注（客户填写）：', 'Note by customer') }}
            </el-text>
            <br />
            <el-input type="textarea" disabled :rows="3" v-model="order.orderMaster.customerNote" />
          </el-col>
          <el-col :span="8">
            <el-text>
              {{ util.language('订单备注（客户可见）：', 'Note for customer') }}
            </el-text>
            <el-button size="small" style="float: right;" @click="saveOrderNote(order)" :loading="loading.saveOrderNote"><!-- v-if="order.orderMaster.state == 'NEW' || show.admin" -->
              {{ util.language('保存', 'Save') }}
            </el-button>
            <br />
            <el-input type="textarea" :rows="3" v-model="order.orderMaster.orderNote" />
          </el-col>
          <el-col :span="8">
            <el-text>{{ util.language('内部备注（客户不可见）：', 'Insider note') }}</el-text>
            <el-button size="small" style="float: right;" @click="saveInsiderNote(order)" :loading="loading.saveInsiderNote"><!-- v-if="order.orderMaster.state == 'NEW' || show.admin" -->
              {{ util.language('保存', 'Save') }}
            </el-button>
            <br />
            <el-input type="textarea" :rows="3" v-model="order.orderMaster.insiderNote" />
          </el-col>
          <el-col :span="24">
            <el-text>{{ util.language('内部备注图片：', 'Insider note image') }}</el-text>
            <br />
            <el-upload accept="image/*" :file-list="order.orderMaster.insiderNoteImgList" :on-preview="insiderNoteImagePreview" :on-error="insiderNoteImageError" list-type="picture-card" :action="api.baseURL() + '/backend/file/upload'"
              :headers="api.tokenHeader()" :on-success="(r, f, fileList) => insiderNoteImageSuccess(order.orderMaster.id, fileList)" :on-remove="(f, fileList) => insiderNoteImageRemove(order.orderMaster.id, fileList)">
              <el-text>{{ util.language('添加图片', 'Add image') }}</el-text>
            </el-upload>
          </el-col>
        </el-row>
      </el-card>
    </div>
    <div style="height: 10px;" />
    <el-pagination v-model:current-page="searchParam.pageNum" v-model:page-size="searchParam.pageSize" :page-sizes="[50, 100, 200]" background layout="total, sizes, prev, pager, next, jumper" :total="data.orderTotal" @change="commitFindList()" />
  </div>

  <el-dialog v-model="show.sendOrder" :title="util.language('发出订单', 'Send order')" width="500" :close-on-click-modal="false">
    <el-form label-width="auto">
      <el-form-item>
        <el-text>{{ util.language('确认送货日期，并将订单标记为已发出？', 'Confirm delivery date and mark the order as sent?') }}</el-text>
      </el-form-item>
      <el-form-item :label="util.language('订单编号', 'Order code')">
        <el-text>{{ data.editing.orderMaster.code }}</el-text>
      </el-form-item>
      <el-form-item :label="util.language('实际配送时间', 'Actual delivery date')">
        <el-date-picker v-model="data.editing.orderMaster.deliveryDate" value-format="YYYY-MM-DD" type="date" style="width: 100%;" />
      </el-form-item>
    </el-form>
    <template #footer>
      <div>
        <el-button @click="show.sendOrder = false">{{ util.language('取消', 'Cancel') }}</el-button>
        <el-button type="primary" @click="sendOrderSubmit" :loading="loading.sendOrder">{{ util.language('确认', 'OK') }}</el-button>
      </div>
    </template>
  </el-dialog>

  <el-dialog v-model="show.finishOrder" :title="util.language('完成订单', 'Finish order')" width="500" :close-on-click-modal="false">
    <el-form label-width="auto">
      <el-form-item>
        <el-text>{{ util.language('将订单标记为完成？', 'Mark the order as finished?') }}</el-text>
      </el-form-item>
      <el-form-item :label="util.language('订单编号', 'Order code')">
        <el-text>{{ data.editing.orderMaster.code }}</el-text>
      </el-form-item>
    </el-form>
    <template #footer>
      <div>
        <el-button @click="show.finishOrder = false">{{ util.language('取消', 'Cancel') }}</el-button>
        <el-button type="primary" @click="finishOrderSubmit" :loading="loading.finishOrder">{{ util.language('确认', 'OK') }}</el-button>
      </div>
    </template>
  </el-dialog>

  <el-dialog v-model="show.editDeliveryInfo" :title="util.language('编辑配送信息', 'Edit delivery info')" width="500" :close-on-click-modal="false">
    <el-form label-width="auto">
      <el-form-item :label="util.language('收货联系人,', 'Contact')">
        <el-input v-model="data.editing.orderMaster.addressContact" />
      </el-form-item>
      <el-form-item :label="util.language('收货联系电话,', 'Phone')">
        <el-input v-model="data.editing.orderMaster.addressPhone" />
      </el-form-item>
      <el-form-item :label="util.language('收货地址,', 'Address')">
        <el-input v-model="data.editing.orderMaster.addressDetail" />
      </el-form-item>
      <el-form-item :label="util.language('预约配送时间,', 'Schedule delivery')" v-if="data.editing.orderMaster.state != 'FINISH' || show.admin">
        <el-date-picker v-model="data.editing.orderMaster.scheduleDeliveryDate" value-format="YYYY-MM-DD" type="date" style="width: 100%;" />
      </el-form-item>
      <el-form-item :label="util.language('实际配送时间', 'Delivery')" v-if="data.editing.orderMaster.state == 'SENT' || data.editing.orderMaster.state == 'FINISH'">
        <el-date-picker v-model="data.editing.orderMaster.deliveryDate" value-format="YYYY-MM-DD" type="date" style="width: 100%;" />
      </el-form-item>
    </el-form>
    <template #footer>
      <div>
        <el-button @click="show.editDeliveryInfo = false">{{ util.language('取消', 'Cancel') }}</el-button>
        <el-button type="primary" @click="saveDeliveryInfo" :loading="loading.saveDeliveryInfo">{{ util.language('确认', 'OK') }}</el-button>
      </div>
    </template>
  </el-dialog>

  <el-dialog v-model="show.editOrderDetail" :title="util.language('编辑商品详情', 'Edit order detail')" width="1400" :close-on-click-modal="false">
    <div style="max-height: 540px;">
      <el-table :data="data.editing.orderDetailList" style="width: 100%;" border>
        <el-table-column :label="util.language('商品', 'Product')" min-width="400">
          <template #default="scope">
            <el-tag style="margin-right: 10px;">
              {{ scope.row.hasUnit ? util.language('按单位（称重）', 'Unit(Weigh)') : util.language('计件', 'Piece') }}
            </el-tag>
            <el-tag style="margin-right: 10px;" type="success" v-if="!scope.row.hasTax">
              {{ util.language('免税', 'No tax') }}
            </el-tag>
            <el-text style="margin-right: 10px;">{{ scope.row.productCode }}</el-text>
            <el-text>{{ util.language(scope.row.productCnName, scope.row.productEnName) }}</el-text>
          </template>
        </el-table-column>
        <el-table-column :label="util.language('数量(件)', 'Piece QTY')" width="175">
          <template #default="scope">
            <el-input-number style="width: 130px; margin-right: 5px;" v-model="scope.row.pieceQuantity" :precision="0" :min="1" :max="scope.row.maxPieceQuantity" @change="changePieceQuantity(scope.row)" />
            <el-tooltip v-if="!scope.row.hasUnit" :content="util.language('按此数量计算价格', 'Calculate price by this quantity')" placement="top">
              <el-text>
                <el-icon>
                  <InfoFilled />
                </el-icon>
              </el-text>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column :label="util.language('数量(单位)', 'Unit QTY')" width="195">
          <template #default="scope">
            <el-input-number style="width: 150px; margin-right: 5px;" v-model="scope.row.unitQuantity" :precision="2" :min="0" />
            <el-tooltip v-if="scope.row.hasUnit" :content="util.language('按此数量计算价格', 'Calculate price by this quantity')" placement="top">
              <el-text>
                <el-icon>
                  <InfoFilled />
                </el-icon>
              </el-text>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="right" :label="util.language('销售单元', 'Sale unit')" width="120">
          <template #default="scope">
            <el-text>{{ scope.row.unitPerPiece }}{{ scope.row.unit }} /{{ util.language('件', 'piece') }}</el-text>
          </template>
        </el-table-column>
        <el-table-column align="right" prop="unitPrice" :label="util.language('单位价格', 'Unit price')" width="160">
          <template #default="scope">
            <el-text>C$</el-text>
            <el-input-number size="small" :controls="false" style="width: 85px;" v-model="scope.row.unitPrice" :precision="2" :min="scope.row.inPrice" />
            <el-text>/{{ scope.row.unit }}</el-text>
          </template>
        </el-table-column>
        <el-table-column align="right" :label="util.language('小计', 'Subtotal')" width="120">
          <template #default="scope">
            <el-text v-if="scope.row.hasUnit">C${{ math.formatNumber(math.halfUp(math.multiply(scope.row.unitQuantity, scope.row.unitPrice), 2)) }}</el-text>
            <el-text v-else>C${{ math.formatNumber(math.halfUp(math.multiply(scope.row.pieceQuantity, scope.row.unitPerPiece, scope.row.unitPrice), 2)) }}</el-text>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="enable" label="" width="45">
          <template #default="scope">
            <el-link type="danger" @click="removeProduct(scope.row)" :underline="false">
              <el-icon>
                <DeleteFilled />
              </el-icon>
            </el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 20px;">
      <el-form :inline="true" style="text-align: right;">
        <el-form-item :label="util.language('商品总价', 'Product amount')">
          <el-text type="danger">C${{ editingTotalAmount }}</el-text>
        </el-form-item>
        <el-form-item :label="util.language('总成本', 'Total cost')">
          <el-text type="danger">C${{ editingTotalCost }}</el-text>
        </el-form-item>
        <el-form-item :label="util.language('HST税费', 'HST amount')" v-if="data.editing.orderMaster.hstRate">
          <el-text type="danger">C${{ editingHstAmount }}</el-text>
        </el-form-item>
        <el-form-item :label="util.language('GST税费', 'GST amount')" v-if="data.editing.orderMaster.gstRate">
          <el-text type="danger">C${{ editingGstAmount }}</el-text>
        </el-form-item>
        <el-form-item :label="util.language('PST税费', 'PST amount')" v-if="data.editing.orderMaster.pstRate">
          <el-text type="danger">C${{ editingPstAmount }}</el-text>
        </el-form-item>
        <el-form-item :label="util.language('QST税费', 'QST amount')" v-if="data.editing.orderMaster.qstRate">
          <el-text type="danger">C${{ editingQstAmount }}</el-text>
        </el-form-item>
        <el-form-item :label="util.language('税后优惠', 'Discount amount')">
          <el-input-number style="width: 140px;" v-model="data.editing.orderMaster.discountAmount" :precision="2" :min="0" :max="math.plus(editingTotalAmount, editingHstAmount, editingGstAmount, editingPstAmount, editingQstAmount)" />
        </el-form-item>
        <el-form-item :label="util.language('总利润', 'Total profit')">
          <el-text type="danger">C${{ math.plus(editingTotalAmount, -editingTotalCost, -data.editing.orderMaster.discountAmount) }}</el-text>
        </el-form-item>
        <el-form-item :label="util.language('利润率', 'Profit rate')">
          <el-text type="danger">{{ math.halfUp(math.divide(math.plus(editingTotalAmount, -editingTotalCost, -data.editing.orderMaster.discountAmount), editingTotalAmount, 0.01), 2) }}%</el-text>
        </el-form-item>
        <el-form-item :label="util.language('订单总价', 'Final amount')">
          <el-text type="danger" style="font-size: large; font-weight: bolder;">
            C${{ math.formatNumber(math.plus(editingTotalAmount, editingHstAmount, editingGstAmount, editingPstAmount, editingQstAmount, -data.editing.orderMaster.discountAmount)) }}
          </el-text>
        </el-form-item>
      </el-form>
    </div>
    <template #footer>
      <div>
        <el-button @click="show.editOrderDetail = false">{{ util.language('取消', 'Cancel') }}</el-button>
        <el-button type="primary" @click="saveOrderDetail" :loading="loading.saveOrderDetail">{{ util.language('确认', 'OK') }}</el-button>
      </div>
    </template>
  </el-dialog>

  <el-dialog v-model="show.history" :title="util.language('订单历史', 'Order history')" width="1400" :close-on-click-modal="false">
    <el-table :data="data.historyList" border style="height: 60vh;">
      <el-table-column :label="util.language('操作', 'Operate')" width="90" align="center">
        <template #default="scope">
          <el-text v-if="scope.row.orderHistory.operate === 'ADD'">{{ util.language('新增', 'New') }}</el-text>
          <el-text v-if="scope.row.orderHistory.operate === 'SET'">{{ util.language('修改', 'Update') }}</el-text>
          <el-text v-if="scope.row.orderHistory.operate === 'DEL'">{{ util.language('删除', 'Delete') }}</el-text>
        </template>
      </el-table-column>
      <el-table-column :label="util.language('操作人', 'Operator')" width="120" align="center">
        <template #default="scope">
          <el-text style="color: rgb(51.2, 126.4, 204);">{{ scope.row.createUser.code }}</el-text>
          <br />
          <el-text>{{ scope.row.createUser.nick }}</el-text>
        </template>
      </el-table-column>
      <el-table-column :label="util.language('时间', 'Time')" width="100" align="center">
        <template #default="scope">
          <el-text>{{ util.parseTime(scope.row.orderHistory.createDatetime) }}</el-text>
        </template>
      </el-table-column>
      <el-table-column :label="util.language('变化前', 'Before')">
        <template #default="scope">
          <div v-if="scope.row.orderHistory.fromData && scope.row.orderHistory.fromData.master">
            <div v-if="scope.row.orderHistory.fromData.master.addressContact">
              <el-text>{{ util.language('收货联系人：', 'Contact: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.fromData.master.addressContact }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.fromData.master.addressPhone">
              <el-text>{{ util.language('收货联系电话：', 'Contact Phone: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.fromData.master.addressPhone }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.fromData.master.addressGooglePlaceId">
              <el-text>{{ util.language('谷歌地图选点：', 'Google Map Point: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.fromData.master.addressGooglePlaceId }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.fromData.master.addressLat">
              <el-text>{{ util.language('维度：', 'Lat: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.fromData.master.addressLat }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.fromData.master.addressLng">
              <el-text>{{ util.language('经度：', 'Lng: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.fromData.master.addressLng }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.fromData.master.addressOpeningHours">
              <el-text>{{ util.language('营业时间：', 'Opening Hours: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.fromData.master.addressOpeningHours }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.fromData.master.addressDetail">
              <el-text>{{ util.language('收货地址：', 'Address: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.fromData.master.addressDetail }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.fromData.master.scheduleDeliveryDate">
              <el-text>{{ util.language('预约配送时间：', 'Schedule Delivery: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.fromData.master.scheduleDeliveryDate }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.fromData.master.deliveryDate">
              <el-text>{{ util.language('实际配送时间：', 'Delivery: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.fromData.master.deliveryDate }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.fromData.master.totalAmount">
              <el-text>{{ util.language('订单总价：', 'Final amount: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.fromData.master.totalAmount }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.fromData.master.hstRate">
              <el-text>{{ util.language('HST税率：', 'HST Rate: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.fromData.master.hstRate }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.fromData.master.gstRate">
              <el-text>{{ util.language('GST税率：', 'GST Rate: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.fromData.master.gstRate }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.fromData.master.pstRate">
              <el-text>{{ util.language('PST税率：', 'PST Rate: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.fromData.master.pstRate }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.fromData.master.qstRate">
              <el-text>{{ util.language('QST税率：', 'QST Rate: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.fromData.master.qstRate }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.fromData.master.discountAmount">
              <el-text>{{ util.language('折扣：', 'Discount: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.fromData.master.discountAmount }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.fromData.master.finalAmount">
              <el-text>{{ util.language('合计：', 'Total: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.fromData.master.finalAmount }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.fromData.master.customerNote">
              <el-text>{{ util.language('客户备注：', 'Note by customer: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.fromData.master.customerNote }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.fromData.master.orderNote">
              <el-text>{{ util.language('订单备注：', 'Note for customer: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.fromData.master.orderNote }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.fromData.master.insiderNote">
              <el-text>{{ util.language('内部备注：', 'Insider note: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.fromData.master.insiderNote }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.fromData.master.insiderNoteImage">
              <el-text>{{ util.language('内部备注图片：', 'Insider note image: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.fromData.master.insiderNoteImage }}</el-text>
            </div>
          </div>
          <div v-if="scope.row.orderHistory.fromData && scope.row.orderHistory.fromData.details && scope.row.orderHistory.fromData.details.length > 0">
            <div v-for="(detail, index) in scope.row.orderHistory.fromData.details" :key="index" style="margin-top: 10px;border-radius: 5px;background-color: rgb(232.8, 233.4, 234.6);">
              <div v-if="detail.id">
                <el-text>{{ util.language('详情ID：', 'Detail ID: ') }}</el-text>
                <el-text style="margin-left: 10px;">{{ detail.id }}</el-text>
              </div>
              <div v-if="detail.productId">
                <el-text>{{ util.language('商品ID：', 'Product ID: ') }}</el-text>
                <el-text style="margin-left: 10px;">{{ detail.productId }}</el-text>
              </div>
              <div v-if="detail.unitPrice">
                <el-text>{{ util.language('单位价格：', 'Unit price: ') }}</el-text>
                <el-text style="margin-left: 10px;">{{ detail.unitPrice }}</el-text>
              </div>
              <div v-if="detail.unitQuantity">
                <el-text>{{ util.language('数量(单位)：', 'Unit QTY: ') }}</el-text>
                <el-text style="margin-left: 10px;">{{ detail.unitQuantity }}</el-text>
              </div>
              <div v-if="detail.pieceQuantity">
                <el-text>{{ util.language('数量(件)：', 'Piece QTY: ') }}</el-text>
                <el-text style="margin-left: 10px;">{{ detail.pieceQuantity }}</el-text>
              </div>
              <div v-if="detail.finalAmount">
                <el-text>{{ util.language('合计：', 'Total: ') }}</el-text>
                <el-text style="margin-left: 10px;">{{ detail.finalAmount }}</el-text>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="util.language('变化后', 'After')">
        <template #default="scope">
          <div v-if="scope.row.orderHistory.toData && scope.row.orderHistory.toData.master">
            <div v-if="scope.row.orderHistory.toData.master.addressContact">
              <el-text>{{ util.language('收货联系人：', 'Contact: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.toData.master.addressContact }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.toData.master.addressPhone">
              <el-text>{{ util.language('收货联系电话：', 'Contact Phone: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.toData.master.addressPhone }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.toData.master.addressGooglePlaceId">
              <el-text>{{ util.language('谷歌地图选点：', 'Google Map Point: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.toData.master.addressGooglePlaceId }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.toData.master.addressLat">
              <el-text>{{ util.language('维度：', 'Lat: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.toData.master.addressLat }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.toData.master.addressLng">
              <el-text>{{ util.language('经度：', 'Lng: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.toData.master.addressLng }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.toData.master.addressOpeningHours">
              <el-text>{{ util.language('营业时间：', 'Opening Hours: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.toData.master.addressOpeningHours }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.toData.master.addressDetail">
              <el-text>{{ util.language('收货地址：', 'Address: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.toData.master.addressDetail }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.toData.master.scheduleDeliveryDate">
              <el-text>{{ util.language('预约配送时间：', 'Schedule Delivery: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.toData.master.scheduleDeliveryDate }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.toData.master.deliveryDate">
              <el-text>{{ util.language('实际配送时间：', 'Delivery: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.toData.master.deliveryDate }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.toData.master.totalAmount">
              <el-text>{{ util.language('订单总价：', 'Final amount: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.toData.master.totalAmount }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.toData.master.hstRate">
              <el-text>{{ util.language('HST税率：', 'HST Rate: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.toData.master.hstRate }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.toData.master.gstRate">
              <el-text>{{ util.language('GST税率：', 'GST Rate: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.toData.master.gstRate }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.toData.master.pstRate">
              <el-text>{{ util.language('PST税率：', 'PST Rate: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.toData.master.pstRate }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.toData.master.qstRate">
              <el-text>{{ util.language('QST税率：', 'QST Rate: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.toData.master.qstRate }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.toData.master.discountAmount">
              <el-text>{{ util.language('折扣：', 'Discount: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.toData.master.discountAmount }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.toData.master.finalAmount">
              <el-text>{{ util.language('合计：', 'Total: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.toData.master.finalAmount }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.toData.master.customerNote">
              <el-text>{{ util.language('客户备注：', 'Note by customer: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.toData.master.customerNote }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.toData.master.orderNote">
              <el-text>{{ util.language('订单备注：', 'Note for customer: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.toData.master.orderNote }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.toData.master.insiderNote">
              <el-text>{{ util.language('内部备注：', 'Insider note: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.toData.master.insiderNote }}</el-text>
            </div>
            <div v-if="scope.row.orderHistory.toData.master.insiderNoteImage">
              <el-text>{{ util.language('内部备注：', 'Insider note image: ') }}</el-text>
              <el-text style="margin-left: 10px;">{{ scope.row.orderHistory.toData.master.insiderNoteImage }}</el-text>
            </div>
          </div>
          <div v-if="scope.row.orderHistory.toData && scope.row.orderHistory.toData.details && scope.row.orderHistory.toData.details.length > 0">
            <div v-for="(detail, index) in scope.row.orderHistory.toData.details" :key="index" style="margin-top: 10px;border-radius: 5px;background-color: rgb(232.8, 233.4, 234.6);">
              <div v-if="detail.id">
                <el-text>{{ util.language('详情ID： ', 'Detail ID: ') }}</el-text>
                <el-text style="margin-left: 10px;">{{ detail.id }}</el-text>
              </div>
              <div v-if="detail.productId">
                <el-text>{{ util.language('商品ID：', 'Product ID: ') }}</el-text>
                <el-text style="margin-left: 10px;">{{ detail.productId }}</el-text>
              </div>
              <div v-if="detail.unitPrice">
                <el-text>{{ util.language('单位价格：', 'Unit price: ') }}</el-text>
                <el-text style="margin-left: 10px;">{{ detail.unitPrice }}</el-text>
              </div>
              <div v-if="detail.unitQuantity">
                <el-text>{{ util.language('数量(单位)：', 'Unit QTY: ') }}</el-text>
                <el-text style="margin-left: 10px;">{{ detail.unitQuantity }}</el-text>
              </div>
              <div v-if="detail.pieceQuantity">
                <el-text>{{ util.language('数量(件)：', 'Piece QTY: ') }}</el-text>
                <el-text style="margin-left: 10px;">{{ detail.pieceQuantity }}</el-text>
              </div>
              <div v-if="detail.finalAmount">
                <el-text>{{ util.language('合计：', 'Total: ') }}</el-text>
                <el-text style="margin-left: 10px;">{{ detail.finalAmount }}</el-text>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <template #footer>
      <div>
        <el-button @click="show.history = false">{{ util.language('关闭', 'Close') }}</el-button>
      </div>
    </template>
  </el-dialog>

  <el-dialog v-model="show.imgUrl" width="50vw" :show-close="false">
    <img width="100%" :src="show.imgUrl">
  </el-dialog>
</template>

<script setup>
import { reactive, ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '../../apis/api'
import apiNative from '../../apis/apiNative'
import cache from '../../utils/cache'
import util from '../../utils/util'
import math from '../../utils/math'

const shopId = cache.getString(cache.keys.shopId) * 1
if (!shopId) {
  ElMessage.error(util.language('请先选择店铺', 'Please select a shop first'))
}
const router = useRouter()
const tabRef = ref()

const data = reactive({
  orderList: [],
  orderTotal: 0,
  editing: null, // 正在编辑中的order
  historyList: [],
})

const show = reactive({
  admin: false,// 超级管理员
  editDeliveryInfo: false, // 正在编辑配送信息
  editOrderDetail: false, // 正在编辑商品详情
  sendOrder: false, // 正在发出订单
  finishOrder: false, // 正在完成订单
  history: false, // 是否显示历史订单
  imgUrl: false, // 是否显示图片
})

const loading = reactive({
  find: false,
  invoice: false,
  exportExcel: false,
  sendOrder: false,
  finishOrder: false,
  saveDeliveryInfo: false,
  saveOrderDetail: false,
  saveInsiderNote: false,
  saveOrderNote: false,
})

api.get('/backend/user/getMyInfo').then(res => {
  if (res.admin) {
    show.admin = true
  }
})

const searchParam = reactive({})
const resetSearchParam = () => {
  searchParam.pageNum = 1
  searchParam.pageSize = 50
  searchParam.createDatetimes = []
  searchParam.code = ''
  searchParam.shopId = shopId
  searchParam.customerCode = ''
  searchParam.stateList = []
}
resetSearchParam()

const buildSearchParam = () => {
  const params = JSON.parse(JSON.stringify(searchParam))
  if (params.createDatetimes.length == 2) {
    params.createDatetimeGe = new Date(params.createDatetimes[0]).getTime()
    params.createDatetimeLt = new Date(params.createDatetimes[1]).getTime()
  }
  delete params.createDatetimes
  if (params.stateList.length > 0) {
    params.stateList = params.stateList.join(',')
  } else {
    delete params.stateList
  }
  return params
}

/** 查询订单列表 */
const commitFindList = (orderCode) => {
  loading.find = true
  const params = buildSearchParam()
  api.get('/backend/order/getPage', { params }).then(res => {
    data.orderList = res.list
    data.orderList.forEach(order => {
      if (order.orderMaster.insiderNoteImg != '') {
        order.orderMaster.insiderNoteImgList = util.json2Elfile(order.orderMaster.insiderNoteImg)
      }
    })

    data.orderTotal = res.total
    if (orderCode != null) {
      if (data.orderList.filter(order => order.orderMaster.code == orderCode).length == 0) {
        ElMessageBox.alert(
          util.language('自动刷新后，订单【' + orderCode + '】不在当前页了', 'The order [' + orderCode + '] is not in the current page after automatic refresh'),
          util.language('提示', 'Tip')
        )
      } else {
        const targetElement = document.getElementById(orderCode);
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }).finally(() => {
    loading.find = false
  })
}
commitFindList()

/** 导出表格 */
const exportExcel = () => {
  loading.exportExcel = true
  const params = buildSearchParam()
  apiNative.get('/backend/order/exportExcel', { params, responseType: 'blob' }).then(res => {
    const fileName = res.headers['content-disposition'].split(';')[1].split('=')[1]
    ElMessage.info(util.language('导出完成，开始下载', 'Export completed, downloading'))
    util.downloadFile(res.data, fileName)
  }).finally(() => {
    loading.exportExcel = false
  })
}

/** 导出发票 */
const invoice = (order) => {
  loading.invoice = true
  ElMessage.info(util.language('正在导出，请稍候', 'Exporting, please wait'))
  apiNative.get('/backend/order/exportInvoicePdf', {
    params: { orderId: order.orderMaster.id },
    responseType: 'blob'
  }).then(res => {
    const fileName = res.headers['content-disposition'].split(';')[1].split('=')[1]
    ElMessage.info(util.language('导出完成', 'Export completed'))
    util.openFile(res.data, fileName)
  }).finally(() => {
    loading.invoice = false
  })
}

/** 下载本页内容中的发票 */
const allInvoice = async () => {
  ElMessage.info(util.language('开始逐个下载发票', 'Start downloading invoices one by one'))
  for (const order of data.orderList) {
    if (order.orderMaster.state != 'FINISH') {
      continue
    }
    apiNative.get('/backend/order/exportInvoicePdf', {
      params: { orderId: order.orderMaster.id },
      responseType: 'blob'
    }).then(res => {
      const fileName = res.headers['content-disposition'].split(';')[1].split('=')[1]
      util.downloadFile(res.data, fileName)
    })
    // 为了避免请求过快，导致服务器压力过大，这里每隔1秒请求一次
    await new Promise(resolve => setTimeout(resolve, 1000))
  }
}

/** 发运订单 */
const sendOrder = (order) => {
  data.editing = JSON.parse(JSON.stringify(order))
  data.editing.orderMaster.deliveryDate = data.editing.orderMaster.scheduleDeliveryDate
  show.sendOrder = true
}

/** 提交完成订单 */
const sendOrderSubmit = () => {
  loading.sendOrder = true
  api.post('/backend/order/sendOrder', {
    orderId: data.editing.orderMaster.id,
    deliveryDate: data.editing.orderMaster.deliveryDate
  }).then(res => {
    ElMessage.success(util.language('保存成功', 'success'))
    commitFindList(data.editing.orderMaster.code)
    data.editing = null
    show.sendOrder = false
  }).finally(() => {
    loading.sendOrder = false
  })
}

/** 完成订单 */
const finishOrder = (order) => {
  data.editing = JSON.parse(JSON.stringify(order))
  show.finishOrder = true
}

/** 提交完成订单 */
const finishOrderSubmit = () => {
  loading.finishOrder = true
  api.post('/backend/order/finishOrder', {
    orderId: data.editing.orderMaster.id,
  }).then(res => {
    ElMessage.success(util.language('保存成功', 'success'))
    commitFindList(data.editing.orderMaster.code)
    data.editing = null
    show.finishOrder = false
  }).finally(() => {
    loading.finishOrder = false
  })
}

/** 取消订单 */
const cancelOrder = (order) => {
  ElMessageBox.confirm(
    util.language('确认要取消订单' + order.orderMaster.code + '？', 'Cancel order ' + order.orderMaster.code + '?'),
    util.language('取消订单', 'Cancel order'), {
    confirmButtonText: util.language('确定', 'OK'),
    cancelButtonText: util.language('取消', 'Cancel'),
  }).then(() => {
    api.post('/backend/order/cancelOrder', {
      orderId: order.orderMaster.id
    }).then(res => {
      ElMessage.success(util.language('保存成功', 'success'))
      commitFindList(order.orderMaster.code)
    })
  })
}

/** 查看订单历史 */
const getHistory = (order) => {
  api.get('/backend/order/getHistoryById', {
    params: { orderId: order.orderMaster.id }
  }).then(res => {
    if (res && res.list) {
      for (const item of res.list) {
        item.orderHistory.fromData = JSON.parse(item.orderHistory.fromData || '{}')
        item.orderHistory.toData = JSON.parse(item.orderHistory.toData || '{}')
      }
      data.historyList = res.list
    } else {
      data.historyList = []
    }
    show.history = true
  })
}

/** 保存订单备注 */
const saveOrderNote = (order) => {
  loading.saveOrderNote = true
  const param = {
    orderMaster: {
      id: order.orderMaster.id,
      orderNote: order.orderMaster.orderNote || '',
    }
  }
  api.post('/backend/order/setOrder', param).then(res => {
    ElMessage.success(util.language('保存成功', 'success'))
    commitFindList(order.orderMaster.code)
  }).finally(() => {
    loading.saveOrderNote = false
  })
}

/** 保存内部备注 */
const saveInsiderNote = (order) => {
  loading.saveInsiderNote = true
  const param = {
    orderMaster: {
      id: order.orderMaster.id,
      insiderNote: order.orderMaster.insiderNote || '',
    }
  }
  api.post('/backend/order/setOrder', param).then(res => {
    ElMessage.success(util.language('保存成功', 'success'))
    commitFindList(order.orderMaster.code)
  }).finally(() => {
    loading.saveInsiderNote = false
  })
}

/** 点击编辑配送相关信息 */
const editDeliveryInfo = (order) => {
  data.editing = JSON.parse(JSON.stringify(order))
  show.editDeliveryInfo = true
}

/** 保存配送相关信息 */
const saveDeliveryInfo = () => {
  loading.saveDeliveryInfo = true
  const param = {
    orderMaster: {
      id: data.editing.orderMaster.id,
      addressContact: data.editing.orderMaster.addressContact,
      addressPhone: data.editing.orderMaster.addressPhone,
      addressDetail: data.editing.orderMaster.addressDetail,
      scheduleDeliveryDate: data.editing.orderMaster.scheduleDeliveryDate,
      deliveryDate: data.editing.orderMaster.deliveryDate,
    }
  }
  api.post('/backend/order/setOrder', param).then(res => {
    ElMessage.success(util.language('保存成功', 'success'))
    show.editDeliveryInfo = false
    commitFindList(data.editing.orderMaster.code)
  }).finally(() => {
    loading.saveDeliveryInfo = false
  })
}

/** 点击编辑详情 */
const editOrderDetail = (order) => {
  data.editing = JSON.parse(JSON.stringify(order))
  data.editing.orderDetailList.forEach(detail => {
    detail.maxPieceQuantity = detail.pieceQuantity
  })
  show.editOrderDetail = true
}

/** 编辑详情自动修改数量 的 弹窗提示 */
let changePieceQuantityAlert = false
/** 编辑详情自动修改数量 */
const changePieceQuantity = (row) => {
  if (changePieceQuantityAlert == false) {
    changePieceQuantityAlert = true
    ElMessage.warning(util.language('自动修改了单位数量，请注意', 'Modify the unit quantity automatically'))
    setTimeout(() => {
      changePieceQuantityAlert = false
    }, 2000)
  }
  row.unitQuantity = math.multiply(row.pieceQuantity, row.unitPerPiece)
}

/** 删除商品 */
const removeProduct = (orderDetail) => {
  data.editing.orderDetailList = data.editing.orderDetailList.filter(detail => detail.id != orderDetail.id)
}

/** 编辑中总金额（不含税） */
const editingTotalAmount = computed(() => {
  let amount = 0
  if (!data.editing) {
    return 0
  }
  data.editing.orderDetailList.forEach(detail => {
    if (detail.hasUnit) {
      amount = math.plus(amount, math.halfUp(math.multiply(detail.unitQuantity, detail.unitPrice), 2))
    } else {
      amount = math.plus(amount, math.halfUp(math.multiply(detail.pieceQuantity, detail.unitPerPiece, detail.unitPrice), 2))
    }
  })
  return math.halfUp(amount, 2)
})

/** 编辑中需要上税总额 */
const editingTotalAmountNeedTax = computed(() => {
  let amount = 0
  if (!data.editing) {
    return 0
  }
  data.editing.orderDetailList.forEach(detail => {
    if (detail.hasTax) {
      if (detail.hasUnit) {
        amount = math.plus(amount, math.halfUp(math.multiply(detail.unitQuantity, detail.unitPrice), 2))
      } else {
        amount = math.plus(amount, math.halfUp(math.multiply(detail.pieceQuantity, detail.unitPerPiece, detail.unitPrice), 2))
      }
    }
  })
  return math.halfUp(amount, 2)
})

/** 编辑中HST税额 */
const editingHstAmount = computed(() => {
  if (data.editing.orderMaster && data.editing.orderMaster.hstRate) {
    return math.halfUp(math.multiply(editingTotalAmountNeedTax.value, data.editing.orderMaster.hstRate), 2)
  } else {
    return 0
  }
})

/** 编辑中GST税额 */
const editingGstAmount = computed(() => {
  if (data.editing.orderMaster && data.editing.orderMaster.gstRate) {
    return math.halfUp(math.multiply(editingTotalAmountNeedTax.value, data.editing.orderMaster.gstRate), 2)
  } else {
    return 0
  }
})

/** 编辑中PST税额 */
const editingPstAmount = computed(() => {
  if (data.editing.orderMaster && data.editing.orderMaster.pstRate) {
    return math.halfUp(math.multiply(editingTotalAmountNeedTax.value, data.editing.orderMaster.pstRate), 2)
  } else {
    return 0
  }
})

/** 编辑中QST税额 */
const editingQstAmount = computed(() => {
  if (data.editing.orderMaster && data.editing.orderMaster.qstRate) {
    return math.halfUp(math.multiply(editingTotalAmountNeedTax.value, data.editing.orderMaster.qstRate), 2)
  } else {
    return 0
  }
})

/** 编辑中总成本 */
const editingTotalCost = computed(() => {
  let amount = 0
  if (!data.editing) {
    return 0
  }
  data.editing.orderDetailList.forEach(detail => {
    if (detail.hasUnit) {
      amount = math.plus(amount, math.halfUp(math.multiply(detail.unitQuantity, detail.inPrice), 2))
    } else {
      amount = math.plus(amount, math.halfUp(math.multiply(detail.pieceQuantity, detail.unitPerPiece, detail.inPrice), 2))
    }
  })
  return math.halfUp(amount, 2)
})

/** 保存编辑详情 */
const saveOrderDetail = () => {
  loading.saveOrderDetail = true
  const orderDetailList = data.editing.orderDetailList.map(detail => {
    const detailFinalAmount = detail.hasUnit ? math.halfUp(math.multiply(detail.unitQuantity, detail.unitPrice), 2)
      : math.halfUp(math.multiply(detail.pieceQuantity, detail.unitPerPiece, detail.unitPrice), 2)
    return {
      id: detail.id || null,
      productId: detail.id != null ? null : detail.productId,
      unitPrice: detail.unitPrice,
      unitQuantity: detail.unitQuantity,
      pieceQuantity: detail.pieceQuantity,
      finalAmount: detailFinalAmount,
    }
  })
  const orderMaster = {
    id: data.editing.orderMaster.id,
    totalAmount: editingTotalAmount.value,
    hstAmount: editingHstAmount.value,
    gstAmount: editingGstAmount.value,
    pstAmount: editingPstAmount.value,
    qstAmount: editingQstAmount.value,
    discountAmount: data.editing.orderMaster.discountAmount,
    finalAmount: math.plus(editingTotalAmount.value, editingHstAmount.value, editingGstAmount.value, editingPstAmount.value, editingQstAmount.value, -data.editing.orderMaster.discountAmount),
  }
  api.post('/backend/order/setOrder', {
    orderMaster, orderDetailList
  }).then(res => {
    ElMessage.success(util.language('保存成功', 'success'))
    show.editOrderDetail = false
    commitFindList(data.editing.orderMaster.code)
  }).finally(() => {
    loading.saveOrderDetail = false
  })
}

/** 上传备注图片成功 */
const insiderNoteImageSuccess = (orderMasterId, fileList) => {
  console.log(fileList)
  const insiderNoteImg = util.elfile2Json(fileList)
  console.log(insiderNoteImg)
  const orderMaster = {
    id: orderMasterId,
    insiderNoteImg: insiderNoteImg,
  }
  api.post('/backend/order/setOrder', {
    orderMaster
  }).then(res => {
    ElMessage.success(util.language('保存成功', 'Save success'))
  })
}

/** 上传备注图片失败 */
const insiderNoteImageError = () => {
  ElMessage.error(util.language('上传失败', 'Upload failed'))
}

/** 移除备注图片 */
const insiderNoteImageRemove = (orderMasterId, fileList) => {
  const insiderNoteImg = util.elfile2Json(fileList)
  const orderMaster = {
    id: orderMasterId,
    insiderNoteImg: insiderNoteImg,
  }
  api.post('/backend/order/setOrder', {
    orderMaster
  }).then(res => {
    ElMessage.success(util.language('删除成功', 'Delete success'))
  })
}

/** 预览备注图片 */
const insiderNoteImagePreview = (file) => {
  const json = util.elfile2Json([file])
  show.imgUrl = JSON.parse(json)[0]
}
</script>

<style lang="less">
.orders {
  .r-table-row {
    border-bottom: rgb(177.3, 179.4, 183.6) 1px solid;
  }

  .avatar-uploaded {
    width: 178px;
    height: 178px;
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    margin-right: 20px;
  }
}
</style>